import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/components/Link';

import './index.scss';

interface Props {
  retryLink?: string | null;
}

const b = b_.with('order-card-status-tooltip-comment');

export const Comment: React.FC<Props> = ({ children, retryLink }) => {
  const { t } = useTranslation();
  return (
    <div className={b()}>
      <span>
        {t('Reject reason')} {children}
      </span>
      {retryLink && (
        <div>
          <Link className={b('link')} to={retryLink}>
            {t('Submit once again')}...
          </Link>
        </div>
      )}
    </div>
  );
};
